import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateNote as CreateNoteMutation,
    CreateNoteVariables as CreateNoteVariables,
    CreateNoteInput,
} from 'nutshell-graphql-types';

import CREATE_NOTE from '../../../timeline/creator/graphql/mutations/create-note.graphql';

export const useCreateNote = (): {
    createNote: (arg1: CreateNoteInput) => Promise<any>;
    isLoading: boolean;
    error: string | null | undefined;
} => {
    const [createNote, {loading, error}] = useMutation<CreateNoteMutation, CreateNoteVariables>(
        CREATE_NOTE
    );

    return {
        createNote: (input: CreateNoteInput) => createNote({variables: {input}}),
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
    };
};
